// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\rapports\columns.js

import { DeleteOutlined, EditOutlined, StarFilled } from "@ant-design/icons";
import { Modal, Button, Popconfirm, message, Tooltip, Typography } from "antd";
import { useDispatch } from "react-redux";
import { deleteRapport } from "../../redux/slices/rapports/rapportsThunk";
import React from 'react';
import dayjs from 'dayjs';

const ActionColumn = ({ record, onEdit }) => {
  const dispatch = useDispatch();

  const handleDelete = (rapportId) => {
    dispatch(deleteRapport(rapportId))
      .unwrap()
      .then(() => {
        message.success("Rapport supprimé.");
      })
      .catch((error) => {
        message.error(`Erreur: ${error}`);
      });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
      <Button 
        className="btn-details" 
        onClick={() => window.open(`/reportdetails/${record.id}`, '_blank')}
      >
        Détails
      </Button>

      <Tooltip title="Modifier la date">
        <EditOutlined 
            style={{ color: '#1890ff', fontSize: '18px', cursor: 'pointer', opacity: 0.8 }} 
            onClick={() => onEdit(record)}
        />
      </Tooltip>

      <Popconfirm
        title="Supprimer ce rapport ?"
        onConfirm={() => handleDelete(record.id)}
        okText="Oui" cancelText="Non"
      >
        <DeleteOutlined style={{ color: '#ff4d4f', fontSize: '18px', cursor: 'pointer', opacity: 0.8 }} />
      </Popconfirm>
    </div>
  );
};

// --- AJOUT DU PARAMÈTRE onOpenHistory ---
export const columns = (onEdit, onOpenHistory) => {
  return [
    {
      title: "Nom",
      dataIndex: "person",
      key: "name",
      render: (person) => {
        if (!person) return 'N/A';
        const isPartner = person.isPartner;
        const fullName = person.type === 2 && person.pharmacien?.pharmacyName 
            ? `${person.pharmacien.pharmacyName} (${person.firstname} ${person.lastname})`
            : `${person.firstname} ${person.lastname}`;
        
        return (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
          }}>
            {/* L'étoile ne s'affiche que si c'est un partenaire */}
            {isPartner && (
              <Tooltip title={`PARTENAIRE : ${person.partnerNotes || ''}`}>
                <StarFilled style={{ color: '#fadb14', fontSize: '16px' }} />
              </Tooltip>
            )}
            
            <a 
                onClick={() => onOpenHistory(person.id)} 
                style={{ 
                    fontWeight: 'bold', 
                    color: isPartner ? '#856404' : '#1890ff',
                    textDecoration: isPartner ? 'underline' : 'none',
                    cursor: 'pointer'
                }}
            >
              {fullName}
            </a>
          </div>
        );
      },
    },
    { 
      title: "Spécialité", 
      dataIndex: "person", 
      key: "specialty", 
      render: (person) => {
        if (person?.type === 2) return <span style={{ fontWeight: "bold", color: "#52c41a" }}>PHAR</span>;
        if (person?.type === 3) return <span style={{ fontWeight: "bold", color: "#faad14" }}>GROS</span>;
        return person?.doctor?.specialty?.abreviation || person?.doctor?.specialty?.name || "N/A";
      }
    },
    {
      title: "Délégué",
      dataIndex: "delegate",
      key: "delegate",
      render: (delegate) => delegate ? `${delegate.firstname} ${delegate.lastname}`.toUpperCase() : 'N/A'
    },
    { title: "Gouvernorat", dataIndex: "government", key: "government", render: (gov) => gov?.name || 'unknown' },
    { title: "Région", dataIndex: "region", key: "region", render: (region) => region?.name || 'N/A' },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (dateString) => dateString ? dayjs(dateString).format('YYYY-MM-DD') : 'N/A',
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 250,
      render: (note) => {
        if (!note || note.trim() === "" || note.trim() === ".") {
          return <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>.</span>;
        }

        // Fonction pour ouvrir la boîte de dialogue (Pop-up)
        const showFullNote = () => {
          Modal.info({
            title: 'Commentaire complet',
            content: (
              <div style={{ marginTop: '20px', fontSize: '16px', lineHeight: '1.6' }}>
                {note}
              </div>
            ),
            width: 600,
            okText: 'Fermer',
            maskClosable: true,
            icon: null,
          });
        };

        return (
          <div style={{ display: 'flex', width: '230px', alignItems: 'center' }}>
            <Typography.Text 
              ellipsis={true} 
              style={{ flex: 1 }}
            >
              {note}
            </Typography.Text>

            {note.length > 20 && (
              <a 
                onClick={showFullNote} 
                style={{ 
                  marginLeft: '8px', 
                  fontWeight: 'bold', 
                  color: '#1890ff',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }}
              >
                Lire plus
              </a>
            )}
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      fixed: 'right',
      render: (record) => <ActionColumn record={record} onEdit={onEdit} />,
    }
  ];
};